/**
 * Shared types for the CampaignForm organism.
 * Used across Create, Modify, and View flows.
 */

/** Form mode — determines field editability and section behaviour */
export const FormMode = {
    CREATE: 'create',
    MODIFY: 'modify',
    VIEW: 'view',
} as const;

// eslint-disable-next-line no-redeclare
export type FormMode = (typeof FormMode)[keyof typeof FormMode];

/** Base props shared by all form section components */
export interface SectionBaseProps {
    /** The current form mode */
    mode: FormMode;
    /** Force-disable override; when omitted, sections default to disabled in 'view' mode */
    disabled?: boolean;
}
